import { Crown } from "lucide-react";

const LABEL = { instagram: "Instagram", story: "Instagram Story", tiktok: "TikTok", whatsapp: "WhatsApp", linkedin: "LinkedIn / X", email: "Email",
  dm: "Messages", invite: "Adelaida invites", gift: "Gifted Resets", moment: "Coach moments", today: "Post today", direct: "Your link" };

// Which channel actually brings people: visitors, signups and members per channel, best one highlighted.
export default function ChannelStats({ channels }) {
  if (!channels?.length) return (
    <p className="text-sm text-muted-foreground mb-12" data-testid="channels-empty">Once people tap your links, you'll see here which channel brings them, so you know where to post.</p>
  );
  const best = channels.find((c) => c.channel !== "direct" && c.visitors) || channels[0]; // a real channel beats the plain link
  const max = Math.max(...channels.map((c) => c.visitors), 1);
  return (
    <section className="rounded-3xl border border-border bg-card/40 p-6 sm:p-7 mb-12" data-testid="partner-channels">
      <h3 className="font-serif text-2xl">Where your people come from</h3>
      <p className="text-xs text-muted-foreground mt-1 mb-5">Best so far: <span className="text-primary" data-testid="channels-best">{LABEL[best.channel] || best.channel}</span>. Post there a little more.</p>
      <div className="space-y-3">
        {channels.map((c) => (
          <div key={c.channel} data-testid={`channel-row-${c.channel}`}>
            <div className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-1.5">{c === best && <Crown className="w-3.5 h-3.5 text-amber-300" />}{LABEL[c.channel] || c.channel}</span>
              <span className="text-xs text-muted-foreground">{c.visitors} visitors · {c.signups} signups · <span className={c.members ? "text-teal-300" : ""}>{c.members} members</span></span>
            </div>
            <div className="h-1.5 rounded-full bg-white/5 mt-1.5 overflow-hidden"><div className={`h-full rounded-full ${c === best ? "bg-primary" : "bg-primary/40"}`} style={{ width: `${Math.max(4, (c.visitors / max) * 100)}%` }} /></div>
          </div>
        ))}
      </div>
    </section>
  );
}
